module.exports = __webpack_public_path__ + "img/pos_s3_img1.5355bc06.png";